import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Avatar,
  Box,
  Button,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Portal,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";

import { ChangeEvent, useEffect, useRef, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import { CreateCenterModal } from "../../components/admin/centers/CreateCenter";
import { EditCenterModal } from "../../components/admin/centers/EditCenter";
import {
  ICenterData,
  ICenterRes,
} from "../../models/admin/center/center,model";
import CenterService from "../../services/admin/center.service";
import Loading from "../../components/common/Loading";

const Centers = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const cancelRef = useRef(null);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [fileteredcenters, setFilteredcenters] = useState<ICenterData[]>([]);
  const [centerList, setcenterList] = useState<ICenterData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [reload, setReload] = useState(false);
  const [isEditcenter, setisEditcenter] = useState(false);
  const [iscenter, setiscenter] = useState(false);
  const [center, setcenter] = useState<ICenterData>();
  const [centerName, setcenterName] = useState<string>();
  const [isOpenAlert, setIsOpenAlert] = useState(false);
  const onCloseAlert = () => setIsOpenAlert(false);
  const [centerId, setcenterId] = useState<string>();
  useEffect(() => {
    // let url = `?pageNumber=${currentPage}&pageSize=${100}&searchString=${query}`
    CenterService.getCenters("")
      .then((data) => {
        const system_center: ICenterRes = data;
        //setPage({ page_total: system_param.pageSize, total: system_param.totalCount, page_count: system_param.totalPages })
        setcenterList(system_center.data.data);
        setFilteredcenters(system_center.data.data);
        setIsLoading(false);
      })
      .catch((err) => err);
  }, [query, reload]);

  const opencenter = () => {
    setisEditcenter(false);
    setiscenter(true);
  };
  const openEditcenter = (param: ICenterData) => {
    setcenter(param);
    setisEditcenter(true);
    setiscenter(false);
  };
  const openDeletecenter = (param: string, name: string) => {
    setcenterId(param);
    setcenterName(name);
    setIsOpenAlert(true);
  };
  const reloadData = () => {
    setReload(!reload);
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredcenters(centerList);
    } else {
      if (centerList) {
        const filtered = centerList.filter((each: any) =>
          each.name.toLowerCase().includes(searchTerm)
        );
        setFilteredcenters(filtered);
      }
    }
  };
  const deletcenter = async () => {
    try {
      const delete_center: any = await CenterService.deleteCenter(centerId);

      if (delete_center) {
        toast({
          title: "Delete center",
          description: `${delete_center.message}`,
          status: "success",
        });
        setReload(!reload);
        setcenterId("");
        setcenterName("");
        onCloseAlert();
      } else {
        toast({
          title: "Delete center",
          description: `${delete_center.message}`,
          status: "error",
        });
      }
    } catch (error: any) {
      toast({
        title: "Delete center",
        description: `${error.response.data.message}`,
        status: "error",
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Box>
          <Flex
            minHeight={"100vh"}
            height={"auto"}
            boxSizing="border-box"
            maxWidth={"100hw"}
          >
            <Box
              width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
              position="relative"
              top="0"
              left="0"
              zIndex="100"
            >
              <AdminSidebar />
            </Box>
            <Box width="100%">
              <AdminDashboardHeader />
              <Box
                py="30px"
                px={["20px", "30px"]}
                width={"100%"}
                bg="#F9F8F8"
                height={"auto"}
                minHeight={"95vh"}
                maxHeight={"95vh"}
                overflowX={"scroll"}
                className="scroll-hidden"
              >
                <Flex
                  justifyContent="space-between"
                  alignItems="baseline"
                  py="26px"
                >
                  <Text color="#2B2B2B" fontWeight="800" fontSize="27px">
                    Centers
                  </Text>
                  <Button
                    colorScheme={"red"}
                    size="sm"
                    fontSize={12}
                    py="7px"
                    px="11px"
                    borderRadius={"2px"}
                    onClick={() => {
                      opencenter();
                    }}
                  >
                    {" "}
                    Add Center
                  </Button>
                </Flex>
                <Box width="100%">
                  <Box>
                    <Flex py="15px" justifyContent="">
                      <InputGroup
                        bg="white"
                        width={["100%", "100%", "50%", "30%"]}
                      >
                        <Input
                          height="40px"
                          onChange={(e) => handleSearchChange(e)}
                          placeholder="Search input here"
                          fontSize={12}
                          size="sm"
                        />
                        <InputRightElement
                          pointerEvents="none"
                          children={<RiSearch2Line color="red" size="0.9rem" />}
                        />
                      </InputGroup>
                    </Flex>
                    <Box width={"100%"}>
                      <TableContainer>
                        <Table size={"sm"}>
                          <Thead py={"15px"}>
                            <Tr bg="white" py={"15px"}>
                              <Td py={"15px"} textTransform={"capitalize"}>
                                {" "}
                                Name
                              </Td>
                              <Td textTransform={"capitalize"}>Address </Td>
                              <Td textTransform={"capitalize"}>State </Td>
                              <Td textTransform={"capitalize"}>LGA</Td>
                              <Td textTransform={"capitalize"}>Code</Td>
                              <Td textTransform={"capitalize"}>Category</Td>
                              <Td textTransform={"capitalize"}>Actions</Td>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {fileteredcenters &&
                              fileteredcenters.length > 0 &&
                              fileteredcenters.map((center, index: number) => (
                                <Tr bg="white" key={index}>
                                  <Td>
                                    <HStack spacing="10px">
                                      <Avatar name={center.name} size="sm" />
                                      <Box>
                                        <Text
                                          fontWeight="600"
                                          fontSize="16px"
                                          color="#616161"
                                        >
                                          {center.name}
                                        </Text>
                                        <Text
                                          fontWeight="500"
                                          fontSize="13px"
                                          color="#616161"
                                        >
                                          {center.email}
                                        </Text>
                                        <Text
                                          fontWeight="500"
                                          fontSize="13px"
                                          color="#616161"
                                        >
                                          {center.phone}
                                        </Text>
                                      </Box>
                                    </HStack>
                                  </Td>
                                  <Td>
                                    <Text
                                      fontSize={"13px"}
                                      textTransform={"capitalize"}
                                      className="wordWrapTable"
                                    >
                                      {center.address
                                        ? center.address.toLowerCase()
                                        : "Nil"}
                                    </Text>
                                  </Td>

                                  <Td>
                                    <Text
                                      fontSize={"13px"}
                                      textTransform={"capitalize"}
                                    >
                                      {center.state ? center.state : "Nil"}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text
                                      fontSize={"13px"}
                                      textTransform={"capitalize"}
                                    >
                                      {center.lga ? center.lga : "Nil"}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text
                                      fontSize={"13px"}
                                      textTransform={"capitalize"}
                                    >
                                      {center.code ? center.code : "Nil"}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <Text
                                      fontSize={"13px"}
                                      textTransform={"capitalize"}
                                    >
                                      {center.category
                                        ? center.category
                                        : "Nil"}
                                    </Text>
                                  </Td>
                                  <Td>
                                    <HStack>
                                      <Button
                                        cursor="pointer"
                                        colorScheme="red"
                                        size={"sm"}
                                        variant={"outline"}
                                        fontSize={"13px"}
                                        onClick={() => {
                                          openEditcenter(center);
                                        }}
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        cursor="pointer"
                                        colorScheme="red"
                                        size={"sm"}
                                        fontSize={"13px"}
                                        onClick={() => {
                                          openDeletecenter(
                                            center.uuid,
                                            center.name
                                          );
                                        }}
                                      >
                                        Delete
                                      </Button>
                                    </HStack>
                                  </Td>
                                </Tr>
                              ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </Box>
                    {iscenter && (
                      <Portal>
                        {" "}
                        <CreateCenterModal
                          isOpencenter={iscenter}
                          onClosed={setiscenter}
                          iscenter={iscenter}
                          reload={reloadData}
                        />{" "}
                      </Portal>
                    )}
                    {isEditcenter && (
                      <Portal>
                        {" "}
                        <EditCenterModal
                          isOpenEditcenter={isEditcenter}
                          onClosed={setisEditcenter}
                          isEditcenter={isEditcenter}
                          reload={reloadData}
                          center={center}
                        />{" "}
                      </Portal>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
            <Portal>
              <AlertDialog
                isOpen={isOpenAlert}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
                size={"sm"}
              >
                <AlertDialogOverlay>
                  <AlertDialogContent>
                    <AlertDialogHeader fontSize="md" fontWeight="semibold">
                      Delete {centerName}
                    </AlertDialogHeader>

                    <AlertDialogBody fontSize={15}>
                      Are you sure? You can't undo this action afterwards.
                    </AlertDialogBody>

                    <AlertDialogFooter>
                      <Button
                        size={"sm"}
                        ref={cancelRef}
                        onClick={onCloseAlert}
                      >
                        Cancel
                      </Button>
                      <Button
                        size={"sm"}
                        colorScheme="red"
                        onClick={deletcenter}
                        ml={3}
                      >
                        Delete
                      </Button>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialogOverlay>
              </AlertDialog>
            </Portal>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default Centers;
